enum IPUnitLocationType {
  Room = 'room',
  Bed = 'bed',
  Toilet = 'toilet',
}

export default IPUnitLocationType;
